import { Title as MantineTitle, TitleProps } from '@mantine/core';

export type ITitleProps = TitleProps;

/** @registry Design-layer pass-through over Mantine Title; import this instead of @mantine/core Title outside src/design. */
export const Title = MantineTitle;
